import { put, select, fork } from 'redux-saga/effects'
import { handleSequentialRequest } from './apiRequestTypes'

export function* acquireLock(action) {
  yield fork(
    [
      this,
      function* (action) {
        const { lockname, patientId = null } = action
        const existingLock = yield findLock(lockname)
        /////////
        /// currently only patient locks exist and only the /patient/id/lock
        /// routes so while the code below is setup to handle both, we are going
        /// to bail out early if it patientId is null since there is nothing on
        /// the api side to handle it yet
        /////////
        if (patientId == null) {
          return
        }
        const url = patientId == null ? 'lock' : `patient/${patientId}/lock`
        const callbacks = {
          400: () => {}, // if we cant get the lock don't do anything
          404: () => {}
        }

        if (existingLock != null) {
          // update the lock
          yield handleSequentialRequest({
            type: 'XTRACT_API_CALL',
            resource: url,
            method: 'update',
            obj: {},
            id: existingLock.lock_id,
            callbacks
          })
        } else {
          // create the lock
          yield handleSequentialRequest({
            type: 'XTRACT_API_CALL',
            resource: url,
            method: 'create',
            obj: { type: lockname },
            callbacks
          })
        }
      }
    ],
    action
  )
}

export function* releaseLock(action) {
  yield fork(
    [
      this,
      function* (action) {
        const { lockname } = action
        const lock = yield findLock(lockname, true)
        if (lock != null) {
          // cancel refresh timer so we stop maintining the lock
          clearInterval(lock.timer)
          // now activly delete the timer
          const { patient_id: patientId = null, lock_id: lockId } = lock
          const url =
            patientId == null
              ? `lock/${lockId}`
              : `patient/${patientId}/lock/${lockId}`
          yield put({
            type: 'XTRACT_API_CALL',
            resource: url,
            method: 'delete',
            callbacks: {
              404: () => null // if the lock has already been deleted don't retry or fail
            }
          })
        }
      }
    ],
    action
  )
}

function* findLock(lockname, withUser = false) {
  const locks = yield select(state => state.locks)
  const auth = yield select(state => state.auth)
  // currently only patient locks exist but at some point multiple types of locks
  // may need to be merged into a single array here.
  // find the lock matching the name
  const lock = locks.patient.find(
    lock =>
      lock.type === lockname && (!withUser || lock.username === auth.username)
  )
  return lock
}
